<script setup lang="ts">
import OzContainedButton, {
  OzContainedButtonColorScheme,
  OzContainedButtonSizePreset,
} from '@@/library/v4/components/OzContainedButton.vue'
import { computed } from 'vue'

const props = defineProps<{
  name: string
  url: string
  darkMode: boolean
  size: 24 | 32 | 40 | 56
}>()

const linkButtonSizePreset = computed(() => {
  switch (props.size) {
    case 24:
      return OzContainedButtonSizePreset.H24px
    case 32:
      return OzContainedButtonSizePreset.H32px
    case 40:
      return OzContainedButtonSizePreset.H40px
    case 56:
      return OzContainedButtonSizePreset.H56px
    default:
      return OzContainedButtonSizePreset.H24px
  }
})
</script>

<template>
  <OzContainedButton
    data-bridged-link="external"
    target="_blank"
    :href="url"
    :dark-mode="darkMode"
    :size-preset="linkButtonSizePreset"
    :color-scheme="OzContainedButtonColorScheme.Bare"
    :class="[
      darkMode
        ? [
            'bg-button-dark hhover:bg-button-hover-dark',
            'hactive:bg-canary-500 hactive:text-dark-text-100',
            'text-light-text-200',
          ]
        : [
            'bg-button-light hhover:bg-button-hover-light',
            'hactive:bg-grape-500 hactive:text-light-text-100',
            'text-dark-text-200',
          ],
    ]"
    :text="name"
  >
  </OzContainedButton>
</template>
